<div class="b-card"> <p class="title">{{title}}</p></div>
<div id="dashboard"></div>

